goog.provide("shadow.js.shim.module$src$svg$wpp$content_actions$data_transfer_svg$default");
shadow.js.shim.module$src$svg$wpp$content_actions$data_transfer_svg$default = shadow.js.shim.module$src$svg$wpp$content_actions$data_transfer_svg.default;
